import TagManager from 'react-gtm-module';

const CD24 = 'Website'

export const pushDataLayer = (data: object) => {
  TagManager.dataLayer({
    dataLayer: data
  })
}

export const INIT_GA = {
  gtmId: 'GTM-PDKX2G7'
}

export const COMMON_GA = (refId: string, partnerName: string, userId : string = "", userType : string = "") => ({
  'event': 'event_Remittance_on_load_vpv',
  'cd2': userId,
  'cd24': CD24,
  'remittance_reference_id': refId,  // We'll be setting this in cd80
  'remittance_parter_name': partnerName, // Pass either either the partner name or partner ID; we'll be setting this in cd82 
  'remittance_user_type': userType
})


//User lands on login page VPV
export const LOGIN_PAGE_LOAD_VPV = (txnId:string) => ({
  'event': 'outward_remittance_vpv', 
  'page_location': 'vpv/outward-remittance/login-page',
  'page_title': 'outward remittance - login page',
  'transaction_id' : txnId,
})
//User lands on login page
export const LOGIN_PAGE_LOAD_PARAM = (txnId:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'login page',
  'transaction_id' : txnId,
})

//User clicks on forgot password
export const FORGOT_PASSWORD_GA = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'Login Page',
  'label': 'forgot password',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User clicks on login
export const LOGIN_CLICKED_GA = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'Login Page',
  'label': 'Login',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User clicks on First time user - registration
export const REGISTER_USER_GA = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'Login Page',
  'label': 'First time user - registration',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User clicks on enable loginid
export const ENABLE_LOGINID_GA = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'Login Page',
  'label': 'enable loginid',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User clicks on use virtual keyboard
export const VIRTUAL_KEYBOARD_GA = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'Login Page',
  'label': 'use virtual keyboard',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User clicks on mpin next
export const MPIN_NEXT_GA = (txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'Login Page',
  'label': 'Next',
  'transaction_id' : txnId,
})

// User lands on transaction details page
export const TRANSACTION_DETAILS_PAGELOAD_VPV = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/transaction-details',
  'page_title': 'outward remittance etb - transaction details',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User lands on transaction details page
export const TRANSACTION_DETAILS_PAGELOAD_PARAM = (userId:string, txnId:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'transaction details',
  'user_id': userId,
  'transaction_id' : txnId,
})

//User clicks on proceed
export const TRANSACTION_DETAILS_PROCEED = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'transaction details',
  'label': 'proceed',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User selects any of the source of funds
export const TRANSACTION_DETAILS_SOF = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'transaction details',
  'label': 'source of funds - '+sourceOfFund,
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on safe usage guideline
export const SAFE_USAGE_CLICK_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'transaction details',
  'label': 'safe usage guideline',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on safe usage guideline checkbox
export const SAFE_USAGE_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'transaction details',
  'label': 'safe usage guideline checkbox',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on  income tax checkbox
export const TAX_DECLARATION_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'transaction details',
  'label': 'income tax checkbox',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on upload bank statement page
export const UPLOAD_STATEMENT_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/upload-bank-statement',
  'page_title': 'outward remittance etb - upload bank statement',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on transaction details page
export const UPLOAD_STATEMENT_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'upload bank statement',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on I will do it later
export const DO_LATER_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'upload bank statement',
  'label': 'I will do it later',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on continue
export const CONTINUE_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'upload bank statement',
  'label': 'continue',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on consent checkbox
export const CONCENT_CHECKBOX_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'upload bank statement',
  'label': 'consent checkbox',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on upload
export const UPLOAD_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'upload bank statement',
  'label': 'upload',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on upload later page
export const UPLOAD_LATER_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/upload-later',
  'page_title': 'outward remittance etb - upload later',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on upload later page
export const UPLOAD_LATER_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'upload later',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on yes
export const UPLOAD_YES_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'upload later',
  'label': 'yes',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on No
export const UPLOAD_NO_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'upload later',
  'label': 'No',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on check your email page
export const EMAIL_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/check-your-email',
  'page_title': 'outward remittance etb - check your email',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on check your email page
export const EMAIL_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'check your email',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on logout
export const EMAIL_LOGOUT_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'check your email',
  'label': 'logout',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

// User lands on payment summary page
export const TRANSACTION_SUMMARY_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/payment-summary',
  'page_title': 'outward remittance etb - payment summary',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

// User lands on payment summary page
export const TRANSACTION_SUMMARY_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'payment summary',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on refresh
export const TRANSACTION_SUMMARY_ACCOUNT_BALANCE_REFRESH = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'payment summary',
  'label': 'refresh',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on continue
export const TRANSACTION_SUMMARY_CONTINUE = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'payment summary',
  'label': 'continue',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

// User lands on tnc page
export const TNC_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/tnc',
  'page_title': 'outward remittance etb - tnc',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on tnc page
export const TNC_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'tnc',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on proceed
export const TNC_PAGE_PROCEED = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'tnc',
  'label': 'proceed',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on tnc checkbox
export const TNC_CHECKBOX_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'tnc',
  'label': 'tnc checkbox',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

// User lands on enter otp page
export const OTP_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/enter-otp',
  'page_title': 'outward remittance etb - enter otp',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on enter otp page
export const OTP_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'enter otp',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on resend otp
export const RESEND_OTP_GA  = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'enter otp',
  'label': 'resend otp',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on confirm
export const OTP_CONFIRM  = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'enter otp',
  'label': 'confirm',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on perfios intermediary page
export const PERFIOS_INTERMEDIARY_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/validation-successful',
  'page_title': 'outward remittance etb - validation successful',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on perfios intermediary page
export const PERFIOS_INTERMEDIARY_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'validation successful',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on successfully submitted page
export const SUCCESS_PAGELOAD_VPV = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/successfully-submitted',
  'page_title': 'outward remittance etb - successfully submitted',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User lands on successfully submitted page
export const SUCCESS_PAGELOAD_PARAM = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'successfully submitted',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on copy urn
export const COPY_URN_GA  = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'successfully submitted',
  'label': 'copy icon - urn',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//User clicks on logout
export const SUCCESS_LOGOUT_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'successfully submitted',
  'label': 'logout',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

// User clicks on profile icon
export const PROFILE_DETAILS = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'profile icon',
  'label': 'profile icon',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

export const FAQ_REDIRECTION_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'profile icon',
  'label': 'FAQ redirection',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

export const PROFILE_LOGOUT_GA = (userId:string, txnAmt:string, txnId:string, purpose:string, sourceOfFund:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'profile icon',
  'label': 'logout',
  'user_id': userId,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
  'customer_info':{
    'purpose' :purpose,
    'source_of_fund' : sourceOfFund
  }
})

//mpin success screens vpv
export const MPIN_SUCCESS_PAGELOAD_VPV = (txnId:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/successful-mpin-login',
  'page_title': 'outward remittance etb - successful mpin login',
  'transaction_id' : txnId,
})

//mpin success screens onload
export const MPIN_SUCCESS_PAGELOAD_PARAM = (txnId:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'successful mpin login',
  'transaction_id' : txnId,
})


// Error Pages
//mpin fail err screens vpv
export const MPIN_FAIL_PAGELOAD_VPV = (loc:string, title:string, txnId:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/mpin-login-failure-' + loc,
  'page_title': 'outward remittance etb - mpin login failure - ' + title,
  'transaction_id' : txnId,
})

//mpin err screens onload
export const MPIN_FAIL_PAGELOAD_PARAM = (label:string, txnId:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': 'mpin login failure - '+label,
  'transaction_id' : txnId,
})

// mpin home btn click
export const MPIN_FAIL_HOME_GA = (action:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': 'mpin login failure - '+action,
  'label': 'home',
  'transaction_id' : txnId,
})

//mpin after success login err screens vpv
export const MPIN_ERROR_PAGELOAD_VPV = (loc:string, title:string, txnAmt:string, txnId:string) => ({
  'event': 'outward_remittance_vpv',
  'page_location': 'vpv/outward-remittance-etb/' + loc,
  'page_title': 'outward remittance etb - ' + title,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
})

//mpin after success login err screens onload
export const MPIN_ERROR_PAGELOAD_PARAM = (label:string, txnAmt:string, txnId:string) => ({
  'event': 'outward_remittance_onload',
  'category': 'outward remittance etb',
  'action': 'pageload',
  'label': label,
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
})

// mpin logout btn click
export const MPIN_ERROR_LOGOUT_GA = (action:string, txnAmt:string, txnId:string) => ({
  'event': 'outward_remittance_onclick',
  'category': 'outward remittance etb',
  'action': action,
  'label': 'logout',
  'transaction_amount' : txnAmt,
  'transaction_id' : txnId,
})

